import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class WorkPosition  {
    _originalTypeClassName = "zERP.BO.WorkPosition";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
WorkPosition.translate = translateService;
}
this.Id = null;
this.Code = null;
this.Name = null;
this.IsActive = false;
this.PolicySector = null;
this.Qualifications = null;
this.CompositionInfo = null;
this.Placement = null;
this.RoleDescription = null;
this.StartDate = null;
this.Scope = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
IsActive:any;
PolicySector:any;
Qualifications:any;
CompositionInfo:any;
Placement:any;
RoleDescription:any;
StartDate:any;
Scope:any;
SeniorityLevel:any;
DutiesResponsibilities:any;
static setSeniorityLevel = ($this, value) => {
var oldValue = $this.SeniorityLevel;
$this.SeniorityLevel = value;
if (value != null) {
}
}
static setDutiesResponsibilities = ($this, value) => {
var oldValue = $this.DutiesResponsibilities;
$this.DutiesResponsibilities = value;
if (value != null) {
}
}

static GetClassName(): any{return "WorkPosition";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}